import React from 'react';
import Navigation from '../components/Navbar'


const Navbar = () => (
  <>
      <Navigation />
  </>
);

export default Navbar;
